<div class="phx-overview-prefix-container">
  <ng-content select="phx-overview-prefix"></ng-content>
  <div class="phx-overview-prefix-loading-placeholder" *ngIf="phxLoading && hasPrefixContent">
    <phx-skeleton phxShape="circle" phxWidth="32px" phxHeight="16px" [phxBackground]="phxBackground"></phx-skeleton>
    <div class="phx-overview-prefix-loading-value-group">
      <phx-skeleton phxShape="circle" phxWidth="58px" phxHeight="40px" [phxBackground]="phxBackground"></phx-skeleton>
      <phx-skeleton phxShape="circle" phxWidth="48px" phxHeight="12px" [phxBackground]="phxBackground"></phx-skeleton>
    </div>
  </div>
</div>
<div class="phx-overview-content-wrapper">
  <div class="phx-overview-header">
    <ng-content select="[phx-overview-header]"></ng-content>
    <div class="phx-overview-header-loading-placeholder" *ngIf="phxLoading">
      <phx-skeleton phxShape="circle" phxWidth="87px" phxHeight="20px" [phxBackground]="phxBackground"></phx-skeleton>
      <phx-skeleton phxShape="circle" phxWidth="87px" phxHeight="20px" [phxBackground]="phxBackground"></phx-skeleton>
    </div>
    <ng-content select="[phx-overview-header-filter]"></ng-content>
    <div class="phx-overview-header-filter-loading-placeholder" *ngIf="phxLoading">
      <phx-skeleton phxShape="circle" phxWidth="120px" [phxHeight]="isMobileView ? '36px' : '20px'" [phxBackground]="phxBackground"></phx-skeleton>
    </div>
  </div>
  <div
    class="phx-overview-body"
    tabindex="0"
    (focus)="onBodyFocus()"
    (keydown)="onKeyDown($event)">
    <ng-content></ng-content>
    <ng-container *ngIf="phxLoading">
      <div *ngFor="let item of loadingItemsArray" class="phx-overview-item-loading-placeholder">
        <phx-skeleton phxShape="circle" phxWidth="57px" phxHeight="16px" [phxBackground]="phxBackground"></phx-skeleton>
        <div class="phx-overview-item-loading-kpi-row">
          <phx-skeleton *ngIf="!isMobileView" phxShape="circle" phxWidth="24px" phxHeight="16px" [phxBackground]="phxBackground"></phx-skeleton>
          <phx-skeleton phxShape="circle" phxWidth="24px" phxHeight="16px" [phxBackground]="phxBackground"></phx-skeleton>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="phx-overview-footer" tabindex="-1">
    <ng-content select="[phx-overview-footer]"></ng-content>
  </div>
</div>
